import React , { useState } from "react";
import { useNavigate } from 'react-router-dom'; 
 
import {api_base_url, base_url} from '../common/Constants';
import Stripe from '@stripe/stripe-js';

 
import {useStripe, useElements, PaymentElement} from '@stripe/react-stripe-js';

const PaymentSection = () => {
  const stripe = useStripe();
  const elements = useElements(); 
  var error_message = "";
  const [error, setError] = useState(""); // Store error message 

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const result = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: base_url+"#/confirmPayment",
      },
    });


    if (result.error) {
      // Show error to your customer (for example, payment details incomplete)
      console.log(result.error.message);
      setError(result.error.message); 
      console.log(error_message);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  };
  return (
    <div>
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <button disabled={!stripe} className="btn-pay">Pay Now</button>
     
    </form>
      {error && <p style={{ color: "red" }}>{error}</p>} {/* Show error */}
        
     </div>
  )
};

export default PaymentSection;